import { useEffect, useState } from 'react';

const useDeviceDetection = () => {
  const [deviceType, setDeviceType] = useState('');

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    // common mobile phone identifiers
    const mobilePhones = ['iphone', 'android', 'windows phone', 'blackberry', 'opera mini', 'opera mobi'];
    // Detect if user agent is mobile
    const isMobilePhone = mobilePhones.some((device) => userAgent.includes(device));

    setDeviceType(isMobilePhone ? 'Mobile' : 'Desktop');
  }, []);

  return deviceType;
};

export default useDeviceDetection;
